if($('.project-map-feature').length > 0){
   var catSelectorProjectMap = $('.project-map-feature .cat-selector');
   var entriesProjectMap = $('.project-map-feature .entries > .entry');
   var mainProjectMapWrap = $('.project-map-feature');
   var mapSize,panZoomWeb,panZoomMobile;

   if(window.matchMedia('(min-width:992px)').matches === true){
      mapSize = 'big';
   }else{
      mapSize = 'small';
   }
   initProjectMap();
//set mapsize onview change
   window.addEventListener('resize', function() {
      var viewChange = false;
      if(window.matchMedia('(min-width:992px)').matches === true){
         if(mapSize !== 'big'){
            mapSize = 'big';
            viewChange = true;
         }
      }else{
         if(mapSize !== 'small'){
            mapSize = 'small';
            viewChange = true;
         }
      }
      initProjectMap();
      if(viewChange === true){
         initProjectMap();
      }
   });

//zoom control
   mainProjectMapWrap.on('click','.zoom-control button',function () {
      switch (mapSize) {
         case 'small':
            if($(this).hasClass('zoomIn')){
               panZoomMobile.zoomIn();
            }else{
               panZoomMobile.zoomOut();
               if(panZoomMobile.getZoom() <= 1){
                  panZoomMobile.reset();
               }
            }
            break;
         case 'big':
            if($(this).hasClass('zoomIn')){
               panZoomWeb.zoomIn();
            }else{
               panZoomWeb.zoomOut();
               if(panZoomWeb.getZoom() <= 1){
                  panZoomWeb.reset();
               }
            }
            break;
      }
   });

//popup data
   mainProjectMapWrap.on('click touchstart','#marker_web > *,#marker_mobile > *',function () {
      var marker = $(this);
      var markerId = $(this).attr('id');
      var popupEntries = $('.project-map-feature .entries').find('[data-mobileid="' + markerId + '"]');
      if(mapSize !== 'small'){
         popupEntries = $('.project-map-feature .entries').find('[data-desktopid="' + markerId + '"]');
      }
      if(popupEntries.length === 1){
         var popupDataEntry = popupEntries.first();
         //generate popup and fill with data
         var popup = $('<div>').addClass('popup');
         $('.project-map-feature .popup').remove()
         var cats = popupDataEntry.data('cat').split(',');
         var categoriesDiv =$('<div class="categories"></div>');
         if(cats.length > 0){
            cats.forEach(function (element) {
               if(element){
                  var cat = $('.project-map-feature .cat-selector').find('.' + element).first().clone();
                  cat.addClass(popupDataEntry.data(element));
                  cat.addClass('cat');
                  categoriesDiv.append(cat);
               }
            })
         }
         popup.append(categoriesDiv);
         popup.append(popupDataEntry.find('h3').first().clone())
         popup.append(popupDataEntry.find('.text').first().clone())
         popup.append('<div class="closer"><img alt="kreuz_icon" src="/typo3conf/ext/st3r_template/Resources/Public/Images/Kreuz_schwarz.svg" width="50" height="50"></div>')
         //place the popup near marker
         popup.css({
            display:'none'
         });
         //show popup
         if(mapSize !== 'small'){
            popup.css({
               top:marker.position().top - marker.closest('svg').offset().top,
               left:marker.position().left - marker.closest('svg').offset().left,
            });
            $('.project-map-feature .map-big').append(popup);
         }else{
            $('.project-map-feature .map-small').append(popup);
         }
         popup.fadeIn();
      }
      if(popupEntries.length > 1){
         //entry has multiple cats
      }
   });

//popup closer
   $('.project-map-feature').on('click touchstart','.closer',function () {
      $(this).closest('.popup').fadeOut();
   });

//filter
   $('.project-map-feature .cat-selector > div').on('click',function () {
      catSelectorProjectMap.find('> div').removeClass('active');
      $(this).closest('.project-map-feature').find('.popup').fadeOut();
      var catSwitch = $(this);
      catSwitch.addClass('active');
      var selectedCat = $(this).data('selectorcat');
      var allMarker = $('.project-map-feature #marker_mobile > *');
      //check which map is visible
      if(mapSize !== 'small'){
         allMarker = $('.project-map-feature #marker_web > *');
      }
      allMarker.fadeOut().promise().done(
          function () {
             mainProjectMapWrap.removeAttr('class');
             mainProjectMapWrap.addClass(selectedCat);
             mainProjectMapWrap.addClass('project-map-feature');
             if(selectedCat === 'all'){
                //big map
                allMarker.fadeIn();
                return true;
             }
             entriesProjectMap.each(function () {
                if($(this).data('cat').indexOf(selectedCat) !== -1){
                   var desktopId = $(this).data('desktopid')
                   var mobileId = $(this).data('mobileid')
                   if(desktopId){
                      $('.project-map-feature svg').find('#'+desktopId).fadeIn();
                   }
                   if(mobileId){
                      $('.project-map-feature svg:visible').find('#'+mobileId).fadeIn();
                   }
                }
             })
          }
      );
   });

//facts
   $('.project-map > div > button.fact-trigger').on('click',function () {
      var button = $(this);
      if (mapSize === 'small') {
         var swapText = $(this).data('swap');
         var oldText = $(this).text();
         button.text(swapText);
         button.data('swap', oldText);
      }
      var projectMapContainer = button.closest('.project-map');

      projectMapContainer.toggleClass('fact-active');
      //mobile
      if (mapSize === 'small') {
         if (projectMapContainer.hasClass('fact-active')) {
            projectMapContainer.find('.map-small:visible').fadeOut(function () {
               projectMapContainer.find('.zoom-control').hide();
               projectMapContainer.find('.facts').slideToggle();
               projectMapContainer.toggleClass('bg-gray');
            });
         } else {
            projectMapContainer.find('.facts').slideToggle(function () {
               projectMapContainer.toggleClass('bg-gray');
               projectMapContainer.find('.map-small').slideDown(function () {
                  projectMapContainer.find('.zoom-control').fadeIn();
               })
            });
         }
      }else {
         //desktop
         projectMapContainer.find('.facts').slideToggle();
      }
   });

   $('.project-map').on('click', '.closer-facts', function () {
      $('.project-map > div >  button.fact-trigger').trigger('click');
   });

   function initProjectMap(){

      if(mapSize === 'big'){
         mainProjectMapWrap.find('.map-big').show();
         initMapZoom('big');
         //mainProjectMapWrap.find('.map-small').hide();
      }else{
         mainProjectMapWrap.find('.map-small').show();
         //svg zoom
         initMapZoom('small');
         //mainProjectMapWrap.find('.map-big').hide();
      }
   }
   function initMapZoom(mapType) {
      if(mapType === 'big'){
         if(panZoomWeb !== undefined){
            panZoomWeb.destroy()
         }
         panZoomWeb = svgPanZoom('#karte_web',{
            minZoom:1,
            maxZoom:5,
            beforePan:function(oldPan, newPan){
               var stopHorizontal = false
                   , stopVertical = false
                   , gutterWidth = this.getSizes().width
                   , gutterHeight = this.getSizes().height
                   // Computed variables
                   , sizes = this.getSizes()
                   , leftLimit = -((sizes.viewBox.x + sizes.viewBox.width) * sizes.realZoom) + gutterWidth
                   , rightLimit = sizes.width - gutterWidth - (sizes.viewBox.x * sizes.realZoom)
                   , topLimit = -((sizes.viewBox.y + sizes.viewBox.height) * sizes.realZoom) + gutterHeight
                   , bottomLimit = sizes.height - gutterHeight - (sizes.viewBox.y * sizes.realZoom)
               var customPan = {}
               customPan.x = Math.max(leftLimit, Math.min(rightLimit, newPan.x))
               customPan.y = Math.max(topLimit, Math.min(bottomLimit, newPan.y))

               return customPan
            }

         });
         panZoomWeb.reset();
         panZoomWeb.resetZoom();
      }else {
         if(panZoomMobile !== undefined){
            panZoomMobile.destroy();
         }
         panZoomMobile = svgPanZoom('#karte_mobile',{
            minZoom:1,
            maxZoom:5,
            preventMouseEventsDefault:true,
            mouseWheelZoomEnabled:false,
            zoomEnabled: false,
            beforePan:function(oldPan, newPan){
               var stopHorizontal = false
                   , stopVertical = false
                   , gutterWidth = this.getSizes().width
                   , gutterHeight = this.getSizes().height
                   // Computed variables
                   , sizes = this.getSizes()
                   , leftLimit = -((sizes.viewBox.x + sizes.viewBox.width) * sizes.realZoom) + gutterWidth
                   , rightLimit = sizes.width - gutterWidth - (sizes.viewBox.x * sizes.realZoom)
                   , topLimit = -((sizes.viewBox.y + sizes.viewBox.height) * sizes.realZoom) + gutterHeight
                   , bottomLimit = sizes.height - gutterHeight - (sizes.viewBox.y * sizes.realZoom)
               var customPan = {}
               customPan.x = Math.max(leftLimit, Math.min(rightLimit, newPan.x))
               customPan.y = Math.max(topLimit, Math.min(bottomLimit, newPan.y))

               return customPan
            }
         });
         panZoomMobile.reset();
         panZoomMobile.resetZoom();
         panZoomMobile.center();
      }
   }
}

